import XmApis from "@src/request/xm/apis"
import CasApis from "@src/request/cas/apis"
// import sessionStorageService from "@src/utils/sessionStorage"
import localStorageService from "@src/utils/localStorage"
import storageKeys from "@src/config/storageKeys"
import appInfor from "@src/config/appInfor"
import utils from "@src/utils"
import configBaseUrl from "@/config/baseUrl"
import registerInfo from "@src/global/registerInfo"

export default class LoginService {
  /**
   * TODO 错误处理
   * Creates an instance of LoginService.
   * @author liupl
   * @param {object} params
   * @param {string!} params.env
   * @param {string!} params.appName
   * @date 2021-07-12
   * @memberof LoginService
   */
  constructor({ env, appName, xmBaseUrl } = {}) {
    env = env || registerInfo.env
    appName = appName || registerInfo.appName
    const params = {
      env,
      appName,
      xmBaseUrl
    }
    this.params = params
    this.xmApis = new XmApis(params)
    this.casApis = new CasApis(params)
    this.appName = params.appName
    this.env = params.env
  }

  async checkLogin() {
    let appBaseInfo = localStorageService.getItem(storageKeys.VOCUST_APP_BASE_ID.key)
    if (appBaseInfo && appBaseInfo.token) {
      const ifLogin = await this.casApis.checkToken({
        token: appBaseInfo.ssoToken
      })
      if (ifLogin.responseStatusType.ack === "Success") return true
      else return false
    } else return false
  }

  async ssoLogin() {
    const signature = await this.xmApis.getSignature()
    console.log(signature)
    // const params = {

    // }
  }

  async login() {
    const appName = this.appName
    let appBaseInfo = {
      appName,
      appId: appInfor[appName].appId
    }

    let resObj = {}
    const pList = new URLSearchParams(location.search)
    pList.forEach((val, key) => {
      resObj[key] = val
    })

    // try {
    if (!resObj.loginType) {
      const { ssoToken, loginSsoToken, responseStatusType = {} } = await this.getSSOToken()
      if (!ssoToken) {
        // 获取返回code
        const errorCode = (responseStatusType?.errors || []).find(item => item.errorCode === -2)
        if (errorCode) return Promise.reject("loginExpired")
        else return Promise.reject("ssoToken error")
      }
      appBaseInfo.ssoToken = ssoToken
      appBaseInfo.loginSsoToken = loginSsoToken
    } else {
      appBaseInfo.ssoToken = encodeURIComponent(resObj.token)
      appBaseInfo.loginSsoToken = ""
    }

    const appToken = await this.getAppToken({ ssoToken: appBaseInfo.ssoToken, type: resObj.loginType || "sso" })
    if (!appToken) return Promise.reject("appToken error")
    if (!appToken.access_token) return Promise.reject("appToken error")
    appBaseInfo.token = appToken.access_token

    appBaseInfo.userInfo = {
      userName: appToken.nick_name || appToken.real_name || appToken.user_name,
      account: appToken.account,
      realName: appToken.real_name,
      tenantId: appToken.tenant_id,
      userId: appToken.user_id,
      avatar: appToken.avatar,
      brand: "",
      tenantName: ""
    }
    // sessionStorageService.setItem(storageKeys.VOCUST_APP_BASE_ID.key, appBaseInfo)
    localStorageService.setItem(storageKeys.VOCUST_APP_BASE_ID.key, appBaseInfo)
    const tenantDetail = await this.getTenantDetail()
    appBaseInfo.userInfo.brand = tenantDetail.logoUrl
    appBaseInfo.userInfo.tenantName = tenantDetail.tenantName
    // 更新 新信息
    localStorageService.setItem(storageKeys.VOCUST_APP_BASE_ID.key, appBaseInfo)
    // } catch (e) {
    //   console.log(e)
    // }
    return appBaseInfo
  }

  /**
   * @description
   * @author liupl
   * @date 2021-07-12
   * @param
   * @return {object} appBaseInfo
   * @memberof LoginService
   */
  async getAppBaseInfo() {
    const appName = this.appName

    let appBaseInfo = localStorageService.getItem(storageKeys.VOCUST_APP_BASE_ID.key)
    // if (!appBaseInfo) {
    //   appBaseInfo = localStorageService.getItem(storageKeys.VOCUST_APP_BASE_ID.key)
    //   if (appBaseInfo) sessionStorageService.setItem(storageKeys.VOCUST_APP_BASE_ID.key, appBaseInfo)
    // }
    if (!appBaseInfo) {
      appBaseInfo = {}
    }
    if (appBaseInfo.appName !== appName) {
      appBaseInfo.appName = appName
      appBaseInfo.appId = appInfor[appName].appId
      localStorageService.setItem(storageKeys.VOCUST_APP_BASE_ID.key, appBaseInfo)
    }
    if (!appBaseInfo.ssoToken) {
      appBaseInfo = await this.login()
    }
    return appBaseInfo
  }

  /**
   * @description 登出
   * @author liupl
   * @date 2021-07-13
   * @param {object} params
   * @param {string} params.service - 返回页面
   * @return {boolean}
   * @memberof LoginService
   */
  async logout({ service, loginDomain } = {}) {
    await this.casApis.logoutBySsoToken()
    // sessionStorageService.removeItem(storageKeys.VOCUST_APP_BASE_ID.key)
    localStorageService.removeItem(storageKeys.VOCUST_APP_BASE_ID.key)
    if (service) {
      service = this.serviceUrlHandler(service)
      service = encodeURIComponent(service)
      let baseUrl = loginDomain || configBaseUrl[this.env].VUE_APP_APICASBASEURL
      const lang = localStorage.getItem("VOC-LANGUAGE") === "en" ? "en-US/" : ""
      window.location.href = `${baseUrl}/${lang}#/login?service=${service}`
      return {
        service,
        loginDomain
      }
    } else {
      return true
    }
  }

  /**
   * @description 处理返回url
   * @author liupl
   * @date 2021-07-15
   * @return {string}
   * @memberof LoginService
   */
  serviceUrlHandler(url) {
    const urlQuery = utils.getUrlQuery(url)
    const filterQuery = []
    Object.keys(urlQuery).forEach(key => {
      if (key !== "ticket") return filterQuery.push(`${key}=${urlQuery[key]}`)
    })
    let backUrl = `${url.split("?")[0]}${filterQuery.length > 0 ? `?${filterQuery.join("&")}` : ""}`
    return backUrl
  }

  /**
   * @description
   * @author liupl
   * @date 2021-07-12
   * @return {string} ssoToken
   * @memberof LoginService
   */
  async getSSOToken() {
    const ticket = await this.getTicket()
    if (!ticket) return Promise.reject("ticket error")
    const signature = await this.xmApis.getSignature()
    let ssoToken = await this.casApis.getToken(
      Object.assign(signature, {
        ticket
      })
    )

    // ssoToken = ssoToken.token
    return {
      ssoToken: ssoToken.token,
      loginSsoToken: ssoToken.ssoToken,
      responseStatusType: ssoToken?.responseStatusType
    }
  }

  /**
   * @description 根据ssotoken换取业务系统token
   * @author liupl
   * @date 2021-07-12
   * @param {object} params
   * @param {string} params.ssoToken
   * @return {object} appToken
   * @memberof LoginService
   */
  async getAppToken({ ssoToken, type }) {
    const params = {
      username: "",
      password: ssoToken,
      scope: "all",
      type: "account",
      grant_type: "password",
      login_type: type || "sso",
      ssoToken: ssoToken
    }
    if (type === "openapi") {
      delete params.ssoToken
    }

    const appToken = await this.xmApis.getToken(params)
    return appToken
  }

  async getTicket() {
    const urlQuery = utils.getUrlQuery()
    if (urlQuery.ticket) {
      if (location) {
        // 拿到 url 上的 ticket 后替换掉
        let url = location.href
        history.replaceState({}, "", url.replace("ticket=", "void="))
      }
      return urlQuery.ticket
    }
    const apiTicket = await this.casApis.getTicket()
    if (apiTicket) return apiTicket
    // else if (urlQuery.ticket) return urlQuery.ticket
    else return null
  }

  /**
   * @description 获取logoUrl
   * @author liupl
   * @date 2021-11-01
   * @memberof LoginService
   */
  async getTenantDetail() {
    const xmApis = new XmApis(this.params)
    const tenantDetail = await xmApis.getTenantDetail()
    return tenantDetail
  }
}
